import styles from '../ApplicationMaintenance.module.scss';
import { useEffect, useState } from 'react';
import AppManagementModel, {
	AppMaster,
} from '../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import Section from '../components/NewApplication/Section';
import AppMasterForm from '../components/NewApplication/AppForms/AppMasterForm';
import AppAuxForm from '../components/NewApplication/AppForms/AppAuxForm';
import UPMCApplicationForm from '../components/NewApplication/AppForms/UPMCApplicationForm';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { GetApplicationManagementByID, UpdateAppTables } from '../_api';
import NewAppRequest from '../../../Classes/ResponseModels/ApplicationManagement/AppManagementRequest';
import ApiErrors from '../components/NewApplication/ApiErrors';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classNames from 'classnames';

const AppTablesUpdate = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [apiErrors, setApiErrors] = useState([]);
	const [isSaving, setIsSaving] = useState(true);
	const [app, setApp] = useState(new AppManagementModel());
	const [savedSuccessfully, setSavedSuccessfully] = useState(null);
	//client side validation errors
	const [appMasterErrors, setAppMasterErrors] = useState([]);

	//on initial load, get AppManagementModel by ID, then set isLoading to false
	useEffect(() => {
		GetApplicationManagementByID(appID)
			.then(res => {
				setApp(res);
			})
			.then(x => {
				setIsSaving(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//when app changes, run client side validations and set corresponding state variables. reset savedSuccessfully to null to hide successful save indicator
	//disable save button if any validation errors are present
	useEffect(() => {
		setAppMasterErrors(AppMaster.validate(app.appMaster));
		setSavedSuccessfully(null);
	}, [app]);

	const handleSave = () => {
		//if there are no client side errors, submit the request. if there are errors, do not allow submission
		if (appMasterErrors.length === 0) {
			const request = new NewAppRequest(
				app,
				currentUser,
				requirementNumber
			);
			setIsSaving(true);
			setApiErrors([]);

			//call api endpoint to update app

			UpdateAppTables(request)
				.then(response => {
					//if errors present, display the errors and re render the form true to the data saved
					//CreateIMSApp returns a new AppManagementModel with data pulled from database for this purpose
					//if an error is present, the data that was saved to the db is pulled and sent back to populate the form, AND THEN the records are removed from the db to allow for resubmission of the form
					if (response?.errors?.length > 0) {
						setApiErrors(response.errors);
					}
					// if no errors set SavedSuccessfully to true to display success message.
					else {
						setSavedSuccessfully(true);
					}
				})
				.then(x => setIsSaving(false));
		}
	};

	const SuccessfulSaveIndicator = () => {
		if (savedSuccessfully === true) {
			return (
				<p className={classNames([styles.margin_left_small])}>
					Saved Successfully
				</p>
			);
		}
	};

	return (
		<>
			{isSaving ? (
				<Spinner />
			) : (
				<>
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								handleSave();
							}}
							startIcon={<MaterialIcon icon='save' />}
							disabled={appMasterErrors.length > 0 || readOnly}
						>
							Save
						</Button>
					</div>
					<div className={styles.controlsContainer}>
						<SuccessfulSaveIndicator />
					</div>
					<ApiErrors errors={apiErrors} />
					<Section label='Application Master'>
						<AppMasterForm
							app={app}
							setApp={setApp}
							validationErrors={appMasterErrors}
						/>
					</Section>
					<Section label='Application Auxiliary'>
						<AppAuxForm app={app} setApp={setApp} />
					</Section>
					<Section label='Application Information (UPMC Application)'>
						<UPMCApplicationForm app={app} setApp={setApp} />
					</Section>
					<div className={styles.controlsContainer}>
						<Button
							onClick={e => {
								handleSave();
							}}
							startIcon={<MaterialIcon icon='save' />}
							disabled={appMasterErrors.length > 0 || readOnly}
						>
							Save
						</Button>
					</div>
					<div className={styles.controlsContainer}>
						<SuccessfulSaveIndicator />
					</div>

					<ApiErrors errors={apiErrors} />
				</>
			)}
		</>
	);
};

export default AppTablesUpdate;
